import React, {useEffect, useRef, useState} from 'react';
import {IonButtons, IonHeader, IonPage} from '@ionic/react';
import {useTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";

import {log} from "@services/firebaseAnalytics.service";

import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from '@components/content/content.style';
import {StyledHeaderButton, StyledHeaderButtonImage} from "@components/button/button.style";

import ArrowLeftImage from "@assets/images/arrow-left.svg";
import ReportApplicationListPane from "@app/helpdesk/reportApplication/panes/reportApplicationListPane.component";
import {Links} from "@app/links";

const ReportApplicationListPage: React.FC = () => {
    const {t} = useTranslation();
    const history = useHistory();

    const header = useRef<HTMLIonHeaderElement>(null);
    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);

    useEffect(() => {
        log('page_visit', {
            page: 'Wnioski -> Lista'
        });

        updateHeight();
    }, []);

    const updateHeight = () => {
        if (header.current?.clientHeight === 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const handleBack = () => {
        history.push(Links.main + Links.helpdesk.menu);
    };

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <IonButtons slot="start">
                            <StyledHeaderButton onClick={() => handleBack()}>
                                <StyledHeaderButtonImage src={ArrowLeftImage}></StyledHeaderButtonImage>
                            </StyledHeaderButton>
                        </IonButtons>
                        <StyledIonTitle>{t("reportApplicationListPage.title")}</StyledIonTitle>
                    </StyledIonToolbar>
                </IonHeader>
                <ReportApplicationListPane topEdge={topEdge}/>
            </StyledIonContent>
        </IonPage>
    );
};

export default ReportApplicationListPage;